import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography'
import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Switch,
    Tab,
    TextField,
} from '@mui/material'
import previewImg from './../../../../../../assets/icons/preview.png'
import AutoCompleteMultiSelect from '../../../../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx';
import CreateNewSchedule from '../CreateNewSchedule/CreateNewSchedule.tsx';
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SchedularPreviewDialog from '../SchedularPreviewDialog/SchedularPreviewDialog.tsx';
import ediPencil from './../../../../../../assets/icons/editPencil.png'


function SchedulerComponent(props) {

 const {showLastOrderTime=false}=props;
 const {showSchedulerTable=false}=props;
 const {defaultData}=props;
 const {selectedItem}=props;
 const {resSaveClicked}=props;
 console.log(selectedItem)
 console.log(resSaveClicked)

console.log(defaultData)
//const [defaultData, setDefaultData]=useState(props.defaultData?props.defaultData:[])
    const apiAddress = process.env.REACT_APP_SECRET;
    const [schedulerDatas, setschedulerDatas] = useState([])
   const[ScheduleErr, setScheduleErr]=useState(false)

    const [selectedSchedularObj, setselectedSchedularObj] = React.useState([]);

    const [selectedSchedule, setselectedSchedule] = React.useState([]);
    
    const addHandleSelect = (data) => {
        console.log(data);
        props.getLastOrderTimeList(data);

      };
  //  const [SchedularPreview, Schedularpreview] = useState([]);

    const [tableData, setTableData] = useState([])

    const addScheduleValue = (dt) => {
        console.log(dt);
        console.log(showLastOrderTime)
        // if (!showLastOrderTime) {
            // if (selectedSchedule.length < 1 || dt.length === 0) {
            //     props.getSchedule(dt);
            //     setselectedSchedule(dt);
            //     setselectedSchedularObj(dt);
            // }
        // } else {
        //     setselectedSchedule(dt);
        //     setselectedSchedularObj(dt);
        //     props.getSchedule(dt);
        // }
                if (dt.length > 1) {
                        // Prevent adding more than one schedule
                        setScheduleErr(true);
                        toast.error("You can only select one schedule at a time.", {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        });
                        return;
                    }
                    if (dt.length === 1 || dt.length === 0) {
                        setScheduleErr(false);
                        props.getSchedule(dt);
                        setselectedSchedule(dt);
                        setselectedSchedularObj(dt);
                    }
        
        setScheduleErr(false);
    
        // Open the preview only if a value is selected
        if (dt && dt.length > 0) {
            setpreviewopen(true);
        }
    };

    const [quantity, setquantity] = React.useState(0);
    const [openAddSection, setOpenAddSection] = React.useState(false);

    const [openSchedule, setSchedule] = React.useState(false);
    const [dialogType, setDialogType] = React.useState('');
    const handleSchedule = (AddSectionData) => {
        setSchedule(AddSectionData);
        loadData();
    }
    const onsave = () => {
        // props.setSchedule(selectedSchedule)
        // props.getSchedule(tableData)
    }

    const loadData = async () => {
        axios({
            method: 'get',
            url: apiAddress + '/api/Schedule',
        })
            .then(function (response) {
                var temp = [];
                console.log(response.data);
                response.data.map((dt, index) => {
                    var obj = {
                        id: dt.scheduleId,
                        title: dt.scheduleName
                    }
                    temp.push(obj)
                })
                tableData.map((dt, i) => {
                    dt.schedule.map((d, j) => {
                        temp = temp.filter(item => item.title !== d.title);
                    })
                })
                setschedulerDatas(temp);

            })
            .catch(function (error) {
                console.log(error);
                toast.error(error.response.data, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            });
    }
const loadDefaultdata=()=>{
    if(schedulerDatas){
        defaultData?.map((dt,i)=>{
        var obj=schedulerDatas.find(x=>x.id==dt?.schedulerId)

        let list = []

        if(obj != undefined){
            list.push(obj)
        }
        console.log(obj)
        console.log(list)
        if(list.length>0){
            setselectedSchedule(list)
        }
        })
    }
}
    useEffect(() => {
        loadData();
    }, [])

    useEffect(()=>{
        loadDefaultdata()
    },[schedulerDatas])

    const [previewopen, setpreviewopen] = React.useState(false)
    const handlePreview = (AddItemData) => {
        setpreviewopen(AddItemData)
    }

    const setDefaultValue = () => {
    
        var list = [];

        props.selectedItem.map((dt, i) => {
            var obj = schedulerDatas.find(x => x.id == dt.id);
            list.push(obj);
        })
        setselectedSchedule(list);

        // tableData.push(list)
        setselectedSchedularObj(list);

        if (props.selectedItem && props.selectedItem.length > 0) {
            setpreviewopen(true);
        }
        console.log(list)
        return list;
    }
    
const[editData,setEditData]=useState()
    const setEditValueFromtable=()=>{
console.log(editData)
    var list = [];
    // data.map((dt,i)=>{
        // var obj = schedulerDatas.find(x => x.id == data.schedule[0].id);
        schedulerDatas.map((dt,i)=>{
            if(dt.id==editData.schedule[0].id){
                var obj=dt 
                console.log(dt)
                list.push(obj); 
            }
        })
        
    // })
    setselectedSchedule(list);
    setselectedSchedularObj(list);
    return list;
    }
   
const handleEdit=(data)=>{
console.log(data)
setEditData(data)
setselectedSchedule(data.schedule)
setquantity(data.quantity)
}
console.log(selectedSchedule)
console.log(tableData)
    const [scheduleName, setScheduleName] = useState([])
    const onAdd = () => {
        selectedSchedule.map((dt,i)=>{
            var obj
            tableData.map((d,j)=>{
                 obj=d.schedule.find(x=>x.title==dt.title)
                 if(obj){
                    tableData.splice(j,1)  
                }
            })
            
        })
       
            if(selectedSchedule.length==0){
                setScheduleErr(true)
            }
            else{
                    var obj = { schedule: selectedSchedule, quantity: quantity }
                    props.getSchedule()
                    tableData.push(obj)
                    props.getSchedule(tableData)
                    var temp = [...schedulerDatas]

                    tableData.map((dt, i) => {
                        dt.schedule.map((d, j) => {
                            temp = temp.filter(item => item.title !== d.title);
                            setScheduleName((prevNames) => [...prevNames, d.title])

                        })

                    })
                    setschedulerDatas(temp);

                    setselectedSchedule([])
                    setquantity(0)
                }
            }
          
    return (
        <div>
            <Grid container sx={{ padding: '0.5rem', marginTop: "1rem" }}>
                <Grid item xs={2}>
                    <Typography>Select Scheduler</Typography>
                </Grid>
                <Grid item xs={7}>
                    {props.isEdit ? (
                        (props.selectedItem && schedulerDatas.length > 0) ?
                            <AutoCompleteMultiSelect
                                label={"Select Scheduler"}
                                placeholder={'Select Scheduler'}
                                value={addScheduleValue}
                                datas={schedulerDatas}
                                val={selectedSchedule}
                                id={2}
                                defaultValue={setDefaultValue}
                            /> : ""
                    ) : editData ? (
                        <AutoCompleteMultiSelect
                            label={"Edit Select Scheduler"}
                            placeholder={'Select Scheduler'}
                            value={addScheduleValue}
                            datas={schedulerDatas}
                            val={selectedSchedule}
                            id={2}
                            defaultValue={setEditValueFromtable}
                        />
                    ) : (
                        // <AutoCompleteMultiSelect
                        //     label={"Select Scheduler"}
                        //     placeholder={'Select Scheduler'}
                        //     value={addScheduleValue}
                        //     datas={schedulerDatas}
                        //     val={selectedSchedule}
                        //     id={2}
                        // />
                        <AutoCompleteMultiSelect
                            label={"Select Scheduler"}
                            placeholder={'Select Scheduler'}
                            value={addScheduleValue}
                            datas={schedulerDatas}
                            val={selectedSchedule}
                            id={2}
                            disableClearable={true} // Disables clearing the selected value
                            isOptionDisabled={(option) =>
                                selectedSchedule.length > 0 && !selectedSchedule.includes(option)
                            } // Disable options other than the selected one
                        />

                    )}
                    {ScheduleErr && <span style={{ color: 'red' }}>This field is required</span>}
                </Grid>

                {/* <Grid item xs={1} >
                    <button className='btn ' style={{ color: "#2a7fd4", fontSize: "1.rem" }} onClick={() => { setpreviewopen(true) }}>
                        <img src={previewImg} style={{ width: "2.5rem" }} />
                    </button>

                </Grid> */}
                <Grid item xs={2} >
                    {/* <Button className='modalAddButton' style={{ color: "blue", fontSize: "1.2rem" }} onClick={() => { setSchedule(true) }}> +Create New Schedule</Button> */}
                    <button className='modalAddButton' onClick={() => { setSchedule(true) }}>+Create New Schedule</button>
                </Grid>
            </Grid>
            {
                props.from === "discount" ? (
                    ""
                ) : (
                    <Grid container sx={{ padding: '0.5rem' }}>
                        <Grid item xs={2}>
                            <Typography style={{ paddingTop: '1rem' }}>
                                Item Quantity
                            </Typography>
                        </Grid>
                        <Grid item xs={10} style={{ paddingTop: '1rem' }}>
                            {/* <TimingComponenet selectedData={selectedData}></TimingComponenet> */}
                            <div className='d-flex' style={{ gap: "5px" }}>
                                <button className={`circleDiv ${quantity === 0 ? "disableMinus" : ""}`} onClick={() => { setquantity(parseInt(quantity) - 1) }}>
                                    <div>
                                        -
                                    </div>
                                </button>
                                <input type="number" pattern="[0-9]*" className='form-control quantityNumber ' value={quantity} onChange={event => { setquantity(event.target.value) }} />
                                <button className='circleDiv' onClick={() => { setquantity(parseInt(quantity) + 1) }}>+</button>
                            </div>
                        </Grid>
                    </Grid>
                )
            }

            <CreateNewSchedule open={openSchedule}
                dialogType={dialogType} onHandleAddItem={handleSchedule} />
            {
                props.from === "discount" ? (
                    ""
                ) : (
                    <>
                        <Grid container sx={{ padding: '0.5rem' }}>

                            <Grid item xs={12}>
                                <div className='d-flex justify-content-end' style={{ gap: "10px" }}>
                                    <Button onClick={onAdd}>Add</Button>
                                </div>
                            </Grid>

                        </Grid>
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th>
                                        Schedule Name
                                    </th>
                                    {
                                        props.from === "discount" ? (
                                            ""
                                        ) : (<th>
                                            Quantity
                                        </th>)

                                    }

                                </tr>
                            </thead>
                            <tbody>
                                {

                                    tableData?.map((dt, i) => (
                                        <tr key={i}>
                                            <td>
                                                <div className='d-flex'>
                                                    {
                                                        dt?.schedule.map((d, j) => (
                                                            <React.Fragment key={j}>
                                                                {j > 0 && ", "}
                                                                {d.title}
                                                            </React.Fragment>
                                                        ))
                                                    }
                                                    <div style={{marginLeft:'5px'}} onClick={()=>handleEdit(dt)}>
                                                       <img src={ediPencil} style={{width:'1rem'}} />
                                                    </div>
                                                </div>    
                                            </td>
                                            {
                                                props.from === "discount" ? (
                                                    ""
                                                ) : (
                                                    <td>
                                                        {dt.quantity}
                                                    </td>
                                                )
                                            }
                                        </tr>
                                    ))
                                }

                            </tbody>
                        </table>
                    </>
                )
            }

            {
                props.from === "discount" ? ("") : (
                    <Grid container sx={{ padding: '0.5rem' }}>
                        <Grid item xs={8}></Grid>
                        <Grid item xs={2}>

                        </Grid>
                        {/* <Grid item xs={2}>
                            <Button className="" onClick={() => { onsave() }}>Save</Button>
                        </Grid> */}
                    </Grid>
                )
            }
            {
                previewopen ? (<SchedularPreviewDialog
                    open={previewopen}
                    onHandleAddItem={handlePreview}
                    addHandleSelect={addHandleSelect}
                    title={props.title}
                    selectedTitle={selectedSchedule}
                    selectedId={selectedSchedularObj}
                    key={selectedSchedularObj}
                    showLastOrderTime={showLastOrderTime}
                    scheduleId={selectedSchedularObj[0]?.id}
                    showSchedulerTable={showSchedulerTable}
                    selecteditem={selectedItem}
                    resSaveClicked={resSaveClicked}
                  />) : ""
            }

        </div>
    );
}

export default SchedulerComponent;